(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gorgias-chat-open.js"] && !Shopify.designMode) return;
  try {
    var gorgias_chat_api_set = {
  frame: null,
  init: function() {this.frame = document.querySelector('div[data-gorgias-widget="true"] iframe#chat-window');if( this.frame !== null ) {this.frame.parentNode.classList.add( 'gorgias-chat-overlay' );this.close();setTimeout(function() { gorgias_chat_api_set.update(); }, 100);}},
  update: function() {if( this.frame !== null ) {this.frame.parentNode.setAttribute('style', 'width: ' +this.frame.offsetWidth +'px;height: ' + ( this.frame.offsetHeight + 32) +'px;' +this.frame.getAttribute('style') );}},
  overlay: function( status ) {
    if( status == 'show' ) {this.frame.parentNode.classList.add('g-ov-show');setTimeout(function() { gorgias_chat_api_set.frame.parentNode.querySelector('.ov-close').style = 'opacity: 1;'; }, 100);}
    if( status == 'hide' ) {this.frame.parentNode.querySelector('.ov-close').style = '';setTimeout(function() { gorgias_chat_api_set.frame.parentNode.classList.remove('g-ov-show'); }, 320);}},
  close: function() {
    if( this.frame.parentNode.querySelector('.ov-close') == null ) {
      var _close = document.createElement('div');
      var _class_close = document.createAttribute("class");
      _class_close.value = 'ov-close';
      _close.setAttributeNode(_class_close);
      _close.innerHTML = `
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" fill="#001f5b"/>
            <path d="M7 17L16.8995 7.10051" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 7.00001L16.8995 16.8995" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `;
        _close.addEventListener('click', function() {GorgiasChat.close();});
        this.frame.parentNode.appendChild(_close);
    }
  }
};
function gorgias_chat_modal__init(){var a=document.querySelectorAll('a[href="#gorgias-chat-open"]');if(a.length>0){for(var b=0;b<a.length;b++){a[b].addEventListener("click",function(c){c.preventDefault();if(typeof GorgiasChat!=="undefined"&&typeof GorgiasChat.open==="function"){ GorgiasChat.open();}})}}}
  document.addEventListener("DOMContentLoaded",function(){
    var initGorgiasChatPromise = (window.GorgiasChat) ?
        window.GorgiasChat.init() :
        new Promise(function (resolve) {window.addEventListener('gorgias-widget-loaded', function () { resolve(); })});
    initGorgiasChatPromise.then(function() {
      GorgiasChat.on('widget:opened', function() {setTimeout(function() {gorgias_chat_api_set.init();gorgias_chat_api_set.overlay('show');},200);});
      GorgiasChat.on('widget:closed', function(data) {setTimeout(function() {gorgias_chat_api_set.init();gorgias_chat_api_set.overlay('hide');},200);});
    });
    window.addEventListener("resize", () => {gorgias_chat_api_set.init();gorgias_chat_api_set.update();});
    gorgias_chat_modal__init();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-thumbnails-navigation"] && !Shopify.designMode) return;
  try {
    (function () {
  const initThumbnailsNavigation = () => {
    // Find all thumbnail Swiper containers on the page
    const thumbnailSliders = document.querySelectorAll('.product-media__slider-thumbnails');

    thumbnailSliders.forEach((sliderEl) => {
      // Prevent double initialization
      if (sliderEl.dataset.navInited) return;

      // Retrieve the Swiper instance injected natively into the DOM element by the library
      const swiperInstance = sliderEl.swiper;

      if (swiperInstance) {
        // Locate navigation buttons within the same container scope
        const prevBtn = sliderEl.querySelector('[class*="js-thumbnails-slider-prev-"]');
        const nextBtn = sliderEl.querySelector('[class*="js-thumbnails-slider-next-"]');

        if (prevBtn && nextBtn) {
          const DISABLED_CLASS = 'swiper-button-disabled';

          // Helper function to update the visual and interactive state of the buttons
          const updateButtonStates = (swiper) => {
            // Handle previous button state (if at the first slide)
            if (swiper.isBeginning) {
              prevBtn.classList.add(DISABLED_CLASS);
              prevBtn.setAttribute('disabled', 'true');
            } else {
              prevBtn.classList.remove(DISABLED_CLASS);
              prevBtn.removeAttribute('disabled');
            }

            // Handle next button state (if at the last slide)
            if (swiper.isEnd) {
              nextBtn.classList.add(DISABLED_CLASS);
              nextBtn.setAttribute('disabled', 'true');
            } else {
              nextBtn.classList.remove(DISABLED_CLASS);
              nextBtn.removeAttribute('disabled');
            }
          };

          // Attach native click events to trigger Swiper methods safely
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            swiperInstance.slidePrev();
          });

          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            swiperInstance.slideNext();
          });

          // Listen to Swiper lifecycle events to update button states dynamically
          swiperInstance.on('slideChange', () => updateButtonStates(swiperInstance));
          swiperInstance.on('update', () => updateButtonStates(swiperInstance));

          // Set initial visual state immediately upon detection
          updateButtonStates(swiperInstance);

          // Mark current container as initialized
          sliderEl.dataset.navInited = "true";
        }
      }
    });
  };

  // Short-interval polling to synchronize with the theme's asynchronous asset loading
  window.addEventListener('DOMContentLoaded', () => {
    let attempts = 0;
    const interval = setInterval(() => {
      initThumbnailsNavigation();
      attempts++;
      if (attempts > 10) clearInterval(interval);
    }, 300);
  });

  // Intercept the theme's EventBus to re-evaluate states during asynchronous product re-renders (e.g., variant changes)
  if (window.themeCore && window.themeCore.EventBus) {
    window.themeCore.EventBus.listen('product:loaded', () => {
      setTimeout(initThumbnailsNavigation, 150);
    });
    window.themeCore.EventBus.listen('product-media:update-complete', () => {
      setTimeout(initThumbnailsNavigation, 150);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
